import React, {forwardRef, useEffect, useState} from 'react';
import SectionLoop from "./SectionLoop";
import Loader from "../../Loader";
import "./PrintCostAndBenefit.scss"
import utilsFunction from "../../../utils/utilsFunction";
import {formatToPersianAddComma, formatToPersianAddCommaNegativeToParentheses} from "../../../utils/CommaSeparator";
import PrintType7Header from "../../Printpage/PrintType7/PrintType7Header";
import PrintType7Footer from "../../Printpage/PrintType7/PrintType7Footer";
import CostAndProfitDataPrintList from "./CostAndProfitDataPrintList";
import PrintType7Header3 from "../../Printpage/PrintType7/PrintType7Header3";


const CostAndProfitDataPrint = forwardRef((props, ref) => {
    const {data} = props;
    debugger

    const [totalSum, setTotalSum] = useState(0)

    useEffect(() => {

      let temp = 0;
      data.data.forEach(row => {
        temp += utilsFunction.removeParenthesesInNumber(row.remaining);
      })

      setTotalSum(temp)
    }, [])
    return (
      <div
        ref={ref}
        className={'PrintCostAndBenefit'}
      >


        <>
          <div>
            {/*<PrintPageCounter data={data} />*/}
            <div className={'border border-black p-2'}>
              <PrintType7Header3 title={data.title} data={data}/>
            </div>
          </div>
          <div>

            <div className={"d-flex justify-content-between border border-black"}>
              {/*<SectionLoop maxItem={maxItem} data={data.data.left}/>*/}
              {/*<SectionLoop maxItem={maxItem} data={data.data.right}/>*/}
              <CostAndProfitDataPrintList data={data.data}/>
            </div>
            <div>
              <div
                className={"p-3 fw-bold  d-flex justify-content-between rounded border border-black"}>
                <div className={'mx-3 d-flex '}>
                  <div className={'mx-1'}></div>
                  <div
                    className={'ltr d-block'}>
                    {/*{formatToPersianAddCommaNegativeToParentheses(totalSum.leftSum)} */}
                  </div>
                </div>

                <div className={'mx-3 d-flex'}>
                  <div className={'mx-1'}> جمع :</div>
                  <div className={'ltr'}>
                    {formatToPersianAddCommaNegativeToParentheses(totalSum)}
                  </div>
                </div>

              </div>

            </div>
          </div>
          <div>
            <div className={'border border-black p-2'}>
              <PrintType7Footer data={data}/>
            </div>
            <div className={'d-block text-center'}>{data.textUnderPrint}</div>

          </div>
        </>
      </div>
    );
  }
)

export default CostAndProfitDataPrint;
